import { useNavigate, useParams } from "react-router-dom";
import { StyledChatPage } from "./ChatPage.styled";
import { Chat } from "../../../models/Chat";
import { useContext, useEffect, useState } from "react";
import { useChat } from "../../../stores/useChat";
import { LanguageContext } from "../../../globals/LanguageContext";
import { Box, Button, Typography } from "@mui/material";
import {
  EnvelopeSimple,
  HouseSimple,
  PencilSimple,
  PhoneCall,
  TrashSimple,
  User,
} from "@phosphor-icons/react";
import { MessageComponent } from "../../../components/message/Message";
import { MessageForm } from "../../../components/chatComponent/messageForm/MessageForm";
import { Confirmation } from "../../../components/confirmation/Confirmation";
import { useProfile } from "../../../stores/useProfile";
import { DarkOverlay } from "../../../components/darkOverlay/DarkOverlay";
import { ContactInfoForm } from "../../../components/form/ContactInfoForm";

export const ChatPage = () => {
  const { id } = useParams();
  const [chat, setChat] = useState<Chat>();
  const [confirmationOpen, setConfirmationOpen] = useState<boolean>(false);
  const [darkOverlayOpened, setDarkOverlayOpened] = useState<boolean>(false);
  const { fetchChat, removeChat } = useChat();
  const { user } = useProfile();
  const { dictionary } = useContext(LanguageContext);
  const navigate = useNavigate();

  useEffect(() => {
    updateItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const updateItems = () => {
    if (!id || !user) return;
    fetchChat(user, Number(id)).then((res) => {
      setChat(res);
    });
  };

  const onConfirm = () => {
    if (!user) return;
    removeChat(user, Number(id)).then((res) => {});
    updateItems();
    navigate("/chats");
  };

  const onSave = () => {
    updateItems();
  };

  if (!id || !chat) return <></>;

  return (
    <StyledChatPage>
      <DarkOverlay
        opened={darkOverlayOpened}
        onClose={() => setDarkOverlayOpened(false)}
        component={
          <ContactInfoForm contactInfo={chat.author} onSave={() => {}} />
        }
      />
      <Box className="header">
        <Button onClick={() => navigate("/chats")}>
          {dictionary.buttons.gobackbtn}
        </Button>
        <Typography variant="h2">
          {chat?.subject}
          <Typography variant="h4">REF: #{chat?.id}</Typography>
        </Typography>
        <TrashSimple
          size={48}
          weight="bold"
          onClick={() => setConfirmationOpen(true)}
        />

        <Confirmation
          confirmationOpen={confirmationOpen}
          onConfirm={onConfirm}
          onDecline={() => {
            setConfirmationOpen(false);
          }}
        />
      </Box>
      <Box className="contactInformationWrapper">
        <Box className="contactinformation">
          <User size={32} weight="bold" />
          <Typography variant="h3">
            {chat?.author.lastName} {chat?.author.firstName}
          </Typography>
        </Box>
        <Box className="contactinformation">
          <EnvelopeSimple size={32} weight="bold" />
          <Typography variant="h3">{chat?.author.email}</Typography>
        </Box>
        <Box className="contactinformation">
          <PhoneCall size={32} weight="bold" />
          <Typography variant="h3">{chat?.author.phone}</Typography>
        </Box>
        <Box className="contactinformation">
          <HouseSimple size={32} weight="bold" />
          <Typography variant="h3">{chat?.author.address}</Typography>
        </Box>
        <PencilSimple
          className="editIcon"
          size={40}
          weight="bold"
          onClick={() => setDarkOverlayOpened(true)}
        />
      </Box>
      <Box className="messageWrapper">
        {chat &&
          chat.messages
            .sort(
              (a, b) =>
                new Date(a.timeStamp).getTime() -
                new Date(b.timeStamp).getTime()
            )
            .map((message) => <MessageComponent message={message} />)}
        <Box className="wrapper">
          <MessageForm chatId={id} onSave={onSave} />
        </Box>
      </Box>
    </StyledChatPage>
  );
};
